"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoControlsResize = void 0;

var react_1 = require("react");

var icons_1 = require("./icons");

var MediaVolumeSlider_1 = require("./MediaVolumeSlider");

var PlayerControls_1 = require("./PlayerControls");

var useVideoControlsResize = function useVideoControlsResize(_ref) {
  var allowFullScreen = _ref.allowFullscreen,
      playerWidth = _ref.playerWidth;
  var resizeInfo = (0, react_1.useMemo)(function () {
    var playPauseIconSize = icons_1.ICON_SIZE;
    var volumeIconSize = icons_1.ICON_SIZE;

    var _fullscreenIconSize = allowFullScreen ? icons_1.fullscreenIconSize : 0;

    var elementsSize = volumeIconSize + playPauseIconSize + _fullscreenIconSize + PlayerControls_1.X_PADDING * 2 + PlayerControls_1.X_SPACER * 2;
    var maxTimeLabelWidth = playerWidth - elementsSize;
    var maxTimeLabelWidthWithoutNegativeValue = Math.max(maxTimeLabelWidth, 0);
    var availableTimeLabelWidthIfVolumeOpen = maxTimeLabelWidthWithoutNegativeValue - MediaVolumeSlider_1.VOLUME_SLIDER_WIDTH; // If max label width is lower than the volume width
    // then it means we need to take it's width as the max label width
    // otherwise we took the available width when volume open

    var computedLabelWidth = availableTimeLabelWidthIfVolumeOpen < MediaVolumeSlider_1.VOLUME_SLIDER_WIDTH ? maxTimeLabelWidthWithoutNegativeValue : availableTimeLabelWidthIfVolumeOpen;
    var minWidthForHorizontalDisplay = computedLabelWidth + elementsSize + MediaVolumeSlider_1.VOLUME_SLIDER_WIDTH;
    var displayVerticalVolumeSlider = playerWidth < minWidthForHorizontalDisplay;
    return {
      maxTimeLabelWidth: maxTimeLabelWidthWithoutNegativeValue,
      displayVerticalVolumeSlider: displayVerticalVolumeSlider
    };
  }, [allowFullScreen, playerWidth]);
  return resizeInfo;
};

exports.useVideoControlsResize = useVideoControlsResize;